"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NursysTransactionStatus = void 0;
exports.instanceOfNursysTransactionStatus = instanceOfNursysTransactionStatus;
exports.NursysTransactionStatusFromJSON = NursysTransactionStatusFromJSON;
exports.NursysTransactionStatusFromJSONTyped = NursysTransactionStatusFromJSONTyped;
exports.NursysTransactionStatusToJSON = NursysTransactionStatusToJSON;
exports.NursysTransactionStatusToJSONTyped = NursysTransactionStatusToJSONTyped;
/**
 *
 * @export
 */
exports.NursysTransactionStatus = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Error: 'ERROR'
};
function instanceOfNursysTransactionStatus(value) {
    for (const key in exports.NursysTransactionStatus) {
        if (Object.prototype.hasOwnProperty.call(exports.NursysTransactionStatus, key)) {
            if (exports.NursysTransactionStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function NursysTransactionStatusFromJSON(json) {
    return NursysTransactionStatusFromJSONTyped(json, false);
}
function NursysTransactionStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NursysTransactionStatusToJSON(value) {
    return value;
}
function NursysTransactionStatusToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=NursysTransactionStatus.js.map